export enum MenuOption {
  Contact = "Contact",
  Password = "Password",
  Preferences = "Preferences",
}
